import { SignupStepStatus } from 'modules/auth/components/SignupStepper/Step'
import { SIGNUP_STEPS } from 'modules/auth/config/signup'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useSignupStoreStep } from '../store/useSignupStore'
import { EnumSignupSteps } from '../types/signup'
import { SignupFormData } from './useSignupForm'

const getStepStatus = (
  step: EnumSignupSteps,
  value: string | undefined,
  signupStep: EnumSignupSteps
): SignupStepStatus => {
  if (signupStep === step) {
    return 'editing'
  }

  return value ? 'done' : 'todo'
}

export const useSignupStepper = () => {
  const { t } = useTranslation('auth-components')
  const { watch } = useFormContext<SignupFormData>()
  const signupStep = useSignupStoreStep()

  const { firstname, lastname, password, email } = watch()

  const stepperValues = useMemo(() => {
    return {
      name: [firstname, lastname].join(' ').trim(),
      email,
      password: password ? '•••••••••••••' : undefined,
    }
  }, [firstname, lastname, password, email])

  return useMemo(
    () =>
      SIGNUP_STEPS.map(({ stepName }) => {
        const stepValue =
          stepName !== EnumSignupSteps.EMAIL_CONFIRM
            ? stepperValues[stepName]
            : undefined
        return {
          key: stepName,
          label: t('signupStepper.step', { context: stepName }),
          value: stepValue,
          status: getStepStatus(stepName, stepValue, signupStep),
        }
      }),
    [stepperValues, t, signupStep]
  )
}
